export default "__VITE_ASSET__6H7RZL0B__"